import React from 'react';
import { Box } from 'edenred-ui';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { BenefitTypeCard } from '@epi-shared/components';
import { ContractedBenefitsSettings } from '@epi-models/pages/BenefitGroups';

interface SelectBenefitsBarProps {
  contractedBenefits: ContractedBenefitsSettings[];
}
export const SelectBenefitsBar = ({
  contractedBenefits
}: SelectBenefitsBarProps) => {
  const {
    sizeMedium,
    fontSemiBold,
    primaryFrontColor,
    lightBlue5,
    primaryBackColorLight20
  } = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      p={3}
      bgcolor={lightBlue5}
      border={`1px solid ${primaryBackColorLight20}`}
      position="sticky"
      top="0"
      zIndex={999}
    >
      <Box
        mb={3}
        fontSize={sizeMedium}
        fontWeight={fontSemiBold}
        color={primaryFrontColor}
      >
        {t('containers.benefit_groups.select_benefits')}
      </Box>
      <Box display="flex" flexDirection="row" flexWrap="wrap" gap={3}>
        {contractedBenefits.map(({ benefitType }) => (
          <BenefitTypeCard
            benefitType={benefitType}
            key={`benefit-card-${benefitType}`}
          />
        ))}
      </Box>
    </Box>
  );
};
